import { ServiceState } from '../../../@types';

const initialState: ServiceState = [];
export default initialState;
